export default "__VITE_ASSET__ByDgXmUd__"